import React from "react";
import Question from "../components/knowledgeCentre/blogs/Question";
import {
  date,
  heading100,
  heading100Light,
  heading150,
  heading200,
  heading500,
  paragraphTextMedium,
  paragraphTextSmall,
} from "../stitches/combinedStyles";
import { styled } from "../stitches/stitches.config";

const BlogArticle = ({ article }: { article: any }) => {
  return (
    <>
      <Container>
        <Title>{article.frontmatter.title}</Title>
        <Published>Published on {article.frontmatter.date}</Published>
        <Content dangerouslySetInnerHTML={{ __html: article.html }} />
      </Container>
      <Question />
    </>
  );
};

export default BlogArticle;

const Container = styled("div", {
  width: "90%",
  margin: "auto",
  maxWidth: 750,
  paddingBottom: 140,
  "@md": {
    marginTop: 120,
  },
});
const Content = styled("div", {
  "& p": {
    ...paragraphTextMedium,
    marginTop: 0,
  },
  "& figcaption": {
    fontFamily: "$opensans",
    fontSize: 14,
    textAlign: "center",
    marginTop: 12,
    color: "$bayoux",
  },
  "& figure": {
    margin: 0,
  },
  "& img": {
    borderRadius: 8,
    overflow: "hidden",
  },
  "& h1, h2, h3, h4, h5, h6 ": {
    ...heading150,
    marginBottom: 6,
    "& strong": {
      ...heading150,
    },
  },
  "& strong": {
    fontWeight: 600,
  },
  "@md": {
    "& p": {
      ...paragraphTextMedium,
    },
  },
});

const Title = styled("h2", {
  ...heading200,
  marginBottom: 8,
  "@md": {
    ...heading500,
    margin: 0,
  },
});

const Published = styled("span", {
  ...date,
  color: "$black100",
});
